import { AxiosResponse } from 'axios';
import ErrorKey from '@/util/ErrorKey';

export interface StandardError {
  errorKey: ErrorKey;
  parameters: string[];
}

export type ErrorKeyString = keyof typeof ErrorKey;

export const StandardErrors = {
  of(errorKey: ErrorKey, ...parameters: string[]): StandardError {
    return {errorKey, parameters};
  },
  wrapResponse(response: AxiosResponse): StandardError {
    const responseError: ErrorKeyString = response.data.error;
    return {
      errorKey: ErrorKey[responseError] || ErrorKey.UnknownBackendError,
      parameters: response.data.parameters || [],
    };
  },
  wrapIfUnknown(error: any, fallbackKey: ErrorKey): StandardError {
    if (error && error.errorKey && error.parameters) {
      return error;
    } else {
      return StandardErrors.of(fallbackKey);
    }
  },
};
